import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useOrgaoService } from 'hooks/useOrgaoService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'

import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Orgaos = (props) => {
  const { route } = props
  const router = useRouter()
  const orgaoService = useOrgaoService()
  const classes = useStyles()
  const [processando, setProcessando] = useState(false)

  const orgaos = useSelector((state) => state.orgaos.orgaos)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    orgaoService.listarOrgaosGlobal(setProcessando)

    
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao} cadastrados`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
      />
      {orgaos && !processando && (
        <Results className={classes.results} dados={orgaos} processando={processando} />
      )}
    </Page>
  )
}
